
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 11.75a.628.628 0 01-.216-.04l-.018-.006a.611.611 0 01-.208-.137L5.81 7.817a.619.619 0 01-.183-.442c0-.167.065-.324.183-.442a.619.619 0 01.442-.183c.166 0 .324.065.441.183l2.684 2.684V1.125a.625.625 0 011.25 0v8.49l2.683-2.683a.62.62 0 01.883 0 .619.619 0 01.184.442.619.619 0 01-.184.442l-3.75 3.75a.635.635 0 01-.205.136l-.021.009a.604.604 0 01-.215.039zM3.126 19.5A3.128 3.128 0 010 16.375v-1.25a.625.625 0 011.25 0v1.25c0 1.034.84 1.875 1.875 1.875h13.75c1.034 0 1.875-.84 1.875-1.875v-1.25a.625.625 0 011.25 0v1.25a3.128 3.128 0 01-3.125 3.125H3.126z"}})])
          )
        }
      }
    